export default "__VITE_ASSET__f799e991__"